import { render, staticRenderFns } from "./EditingFigureDefinition.vue?vue&type=template&id=51e17e20&"
import script from "./EditingFigureDefinition.vue?vue&type=script&lang=js&"
export * from "./EditingFigureDefinition.vue?vue&type=script&lang=js&"
import style0 from "./EditingFigureDefinition.vue?vue&type=style&index=0&id=51e17e20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports